import { loadStripe } from "@stripe/stripe-js"

// Localhost (REACT_APP_API_LOCAL=1, set by the start:* scripts but never by build) always
// uses Stripe's TEST account so billing can be exercised with test cards. The API makes
// the same switch on IS_LOCALHOST - both sides must agree or SetupIntents won't confirm.
// This flag is also what picks which slot of the org document to read add-on state from
// (see getPurchasingStripe in utils/purchasing-plan.js): the API keeps test-account state
// in purchasing.stripeTest and live-account state in purchasing.stripe, side by side.
export const IS_STRIPE_TEST_MODE = Boolean(process.env.REACT_APP_API_LOCAL && process.env.REACT_APP_STRIPE_TEST_KEY)

export const STRIPE_PUBLISHABLE_KEY = IS_STRIPE_TEST_MODE
    ? process.env.REACT_APP_STRIPE_TEST_KEY
    : process.env.REACT_APP_STRIPE_KEY

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)

export default stripePromise
